import api from "../utils/api";

const API_URL = process.env.REACT_APP_API_URL + "/discussions.php";

// Get all extra charges by project ID
export const getDiscussionsByProjectId = async (projectId) => {
  const response = await api.post(API_URL, {
    action: "getByProject",
    projectId: projectId,
  });
  return response.data.discussions || [];
};

// Add a new Discussion
export const addDiscussion = async (data) => {
  const response = await api.post(API_URL, {
    ...data,
    action: "add",
  });
  return response.data;
};

// Update an Discussion
export const updateDiscussion = async (data) => {
  const response = await api.post(API_URL, {
    ...data,
    action: "update",
  });
  console.log(response.data);
  return response.data;
};

// Delete an Discussion (optional)
export const deleteDiscussion = async (id) => {
  const response = await api.post(API_URL, {
    id,
    action: "delete",
  });
  return response.data;
};

export async function sendApprovalLink(discussionId) {
  const response = await api.post(API_URL, {
    id: discussionId,
    action: "send",
  });
  console.log(response.data);
  return response.data;
}
